import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  RecipePageState,
  RecipeState,
  SubStepTypes,
  subStepTypesE3,
} from "./recipePage.types";
import { setEditSubstep } from "../recipeCreation/createRecipe.slice";
import { RootState } from "../store/store";
import { Recipe } from "../recipeCreation/createRecipe.types";
//TODO  handle session storage as well
export const initialState: RecipePageState = {
  experience2View: "default",
  allVideosMuted: false,
  loading: false,
  servingSize: 2,
  isViewRecipeOpen: false,
  substepEdit: {
    substepOperation: null,
    substepId: null,
    subStepUId: null,
  }
};

export const recipePageSlice = createSlice({
  name: "recipePage",
  initialState,
  reducers: {
    setServingSize: (state, action: PayloadAction<number>) => {
      state.servingSize = action.payload;
    },
    setAllVideosMuted: (state, action: PayloadAction<boolean>) => {
      state.allVideosMuted = action.payload;
    },
    setRecipe: (state, action: PayloadAction<{ recipe: RecipeState }>) => {
      const recipe = action.payload.recipe;
      const minServing = recipe.metadata.minServing;
      const maxServing = recipe.metadata.maxServing;
      const defaultServingSize = minServing <= 2 && maxServing !== 1 ? 2 : minServing
      state.servingSize = defaultServingSize;
      state.recipe = recipe;
    },
    setRecipeAndIngredients: (state, action: PayloadAction<{ recipe: RecipeState, newRecipedata: Recipe, ingredients: Array<any> }>) => {
      const recipe = action.payload.recipe;
      const minServing = recipe.metadata.minServing;
      const maxServing = recipe.metadata.maxServing;
      const defaultServingSize = minServing <= 2 && maxServing !== 1 ? 2 : minServing
      state.servingSize = defaultServingSize;
      state.recipe = recipe;
    },
    setIsViewRecipeOpen: (state, action: PayloadAction<boolean>) => {
      state.isViewRecipeOpen = action.payload;
    },
    setSubstepEdit: (state, action: PayloadAction<{ substepOperation: string, substepId: string, subStepUId: string }>) => {
      state.substepEdit.substepOperation = action.payload.substepOperation;
      state.substepEdit.substepId = action.payload.substepId;
      state.substepEdit.subStepUId = action.payload.subStepUId;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(setEditSubstep, (state, action) => {
      state.substepEdit.substepOperation = action.payload.substepOperation;
      state.substepEdit.substepId = action.payload.substepId;
      state.substepEdit.subStepUId = action.payload.subStepUId;
    })
  }
});

export const { setServingSize, setRecipe, setIsViewRecipeOpen, setSubstepEdit, setRecipeAndIngredients, setAllVideosMuted } = recipePageSlice.actions;

export default recipePageSlice.reducer;

export const changeRecipeOnServing = (recipe: any, servingSize: number) => {
  const { steps } = recipe;
  const newSteps = steps.map((step: any) => {
    const { subSteps } = step;

    const newSubSteps = subSteps.map((subStep: any) => {
      const subStepType = subStep.type;
      if (
        subStepType === SubStepTypes.description.addIngredients ||
        subStepType === SubStepTypes.criticalStep) {
        const { items } = subStep.parameters;
        const newItems = items.map((item: any) => {
          const { scaleModel } = item;
          const usedQty = getScaledVal(
            Number(item.amount.qty),
            scaleModel?.parameters,
            scaleModel?.type,
            servingSize
          );
          return { ...item, overruledAmount: { ...item.amount, qty: usedQty } };
        });

        return {
          ...subStep,
          parameters: { ...subStep.parameters, items: newItems },
        };
      } else if (
        subStepType === SubStepTypes.description.addIngredientsWithAlternate || subStepType === subStepTypesE3.ingredients

      ) {
        const { items } = subStep.parameters;
        const newItems = items.map((item: any) => {
          const { ingredients } = item;
          const newIngredients = ingredients.map((ingredient: any) => {
            const { scaleModel } = ingredient;
            const usedQty = getScaledVal(
              Number(ingredient.amount.qty),
              scaleModel?.parameters,
              scaleModel?.type,
              servingSize
            );
            return {
              ...ingredient,
              overruledAmount: { ...ingredient.amount, qty: usedQty },
            };
          });
          return { ingredients: newIngredients };
        });

        return {
          ...subStep,
          parameters: { ...subStep.parameters, items: newItems },
        };
      } else {
        return subStep;
      }
    });

    return { ...step, subSteps: newSubSteps };
  });
  return { ...recipe, steps: newSteps, serving: servingSize };
};

const getScaledVal = (
  baseValue: any,
  parameters: any,
  scaleType: any,
  servingSize: number
) => {
  switch (scaleType) {
    case "linear":
      {
        const checkedScaleFactor = parameters?.scaleFactor || 0;
        const checkedServingSize = servingSize || 0;
        if (typeof baseValue === "number") {
          const scaledValue = Math.max(
            Number(baseValue) + (checkedServingSize - 2) * checkedScaleFactor,
            0
          );
          return scaledValue;
        } else if (typeof baseValue === "object") {
          const { time, temperature, speed } = baseValue;
          const scaledTime = Math.max(
            Number(time) + (checkedServingSize - 2) * checkedScaleFactor,
            0
          );
          return { time: scaledTime, temperature, speed };
        }
      }
      break;
    case "hardcode": {
      const { settings } = parameters;
      const { time, temperature, speed } = settings.find(
        (i: any) => i.servingSize === servingSize
      );
      return { time, temperature, speed };
    }
    case "hardcode-ingredient": {
      const scaledIngredient = parameters.scaledQty.find(
        (i: any) => i.servingSize === servingSize
      ).value;
      return scaledIngredient;
    }
    default: {
      return baseValue;
    }
  }
};

export const allMediaMutedSelector = (state: RootState) => state.recipePage.allVideosMuted;
export const isViewRecipeOpenSelector = ((state: RootState) => state.recipePage.isViewRecipeOpen)
export const newRecipeDataSelector = (state: RootState) => state.recipePage.recipe;

export const changeIngredientsOnServing = (subSteps: any, servingSize: number) => {
  const scaledIngredientsList: { qty: number, unit: string, ingredientId: string }[] = []
  subSteps.forEach((subStep: any) => {
    subStep.parameters.items.forEach((item: any) => {
      const { ingredients } = item;
      const defaultIngredient = ingredients.find((ingredient: any) => ingredient.default)
      const { scaleModel } = defaultIngredient;
      const { unit } = defaultIngredient.amount;
      const usedQty = getScaledVal(
        Number(defaultIngredient.amount.qty),
        scaleModel?.parameters,
        scaleModel?.type,
        servingSize
      );
      scaledIngredientsList.push({ qty: usedQty, unit, ingredientId: defaultIngredient.ingredientId })
    });
  })
  return scaledIngredientsList;
};